import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Button,
  TextInput,
  Pagination,
} from '@techsoftware/happay-widgets';
import Icon from '@techsoftware/happay-widgets/FontIcon';
import Shimmer from '@techsoftware/happay-widgets/Shimmer';
import history from '../../utils/history';
import Table from '../customComponent/customTable';
import TableConfig from '../../constants/tableListing/tableConfig';
import NoContent from '../customComponent/noContent';
import EMPTYSCREENHOMEINV from '../../assets/images/nocontent/home-inv-admin.svg';
import EMPTYSCREENHOMEVEN from '../../assets/images/nocontent/home-ven-admin.svg';
import EMPTYSCREENMYINV from '../../assets/images/nocontent/my-inv.svg';
import FILTERNODATA from '../../assets/images/nocontent/filter-empty-state.svg';
import GenericFilter from '../../containers/filterContainer';
import CardConstant from '../../constants/expense';
import DynamicButtons from '../dynamicButtons';
import ActionConfirmation from '../ActionConfirmation';
import InvoiceBulk from '../../containers/invoiceBulkContainer';
import { scrollTable } from '../../utils/common';

const { expenseFilters } = CardConstant;
const initialPageSize = 20;

function Expenses(props) {
  const [state, setState] = useState({
    currentPage: 1,
    count: (props && props.expenses && props.expenses.count) || 0,
    pageSize: initialPageSize,
    openDisputeDialog: false,
    defaultQueryObj: {},
    comment: '',
    selectedDispute: '',
    currentTxn: '',
    currentTxnAmt: '',
    filterBy: '', //getDefaultFilter(),
    viewDisputeDialog: false,
    disputeObj: {},
    targetId: null,
    tooltip: false,
    disputeTooltipStatus: '',
    openEmandate: false,
    globalSearchVal: '',
    openDeleteInvVen: false,
    invVenId: '',
    globalSearchErrText: '',
    // filterQuery: {},
    checkedColumns: [], //columnConfig?.[location?.pathname]?.['Saved'],
    selectedRows: [],
  });
  const pathname = props?.pathname
    ? props.pathname
    : props?.history?.location?.pathname || null;

  const { filterQuery = {} } = props;

  let localFilterQuery = {};

  useEffect(
    () => () => {
      props.clearexpense(); // This works as willUnmount
    },
    [],
  );

  useEffect(() => {
    // This is done to reinitialize the filterquery when redirected back from detail view, in detail view this component will be unmounted. So we are reinilizing the query when the component is mounted back.
    // NOTE: Component is already mounted when the navbar tabs are changed, so this section wont render.
    localFilterQuery = props.filterQuery;
  }, []);

  useEffect(() => {
    if (props.savedColumn?.length !== state.checkedColumns?.length) {
      setState({
        ...state,
        checkedColumns: props.savedColumn,
      });
    }
  }, [props.savedColumn]);

  useEffect(() => {
    setDefaultPageState(true);
  }, [pathname]);

  useEffect(() => {
    if (props.invoiceBulkSuccess) {
      setDefaultPageState();
    }
  }, [props.invoiceBulkSuccess]);

  function getDefaultFilter() {
    let defaultFilter = '';
    if (props?.history?.location?.search) {
      let urlQuery = props.history.location.search.split('=')[1];
      if (urlQuery) {
        if (urlQuery.split('&').length) {
          defaultFilter = urlQuery.split('&')[0];
        } else {
          defaultFilter = urlQuery;
        }
      }
      // defaultFilter = props?.history?.location?.search.split('=')[1];
    } else if (pathname === '/invoice/myinvoice') {
      defaultFilter = 'Saved';
    } else if (pathname === '/invoice/myapproval') {
      defaultFilter = 'Pending';
    } else if (pathname === '/vendor/myvendor') {
      defaultFilter = 'Saved';
    } else if (
      pathname === '/vendor/myapproval' ||
      pathname === 'dashboardAdminInvoice' ||
      pathname === 'dashboardAdminVendor' ||
      pathname === 'dashboardUserVendor' ||
      pathname === 'dashboardUserInvoice'
    ) {
      defaultFilter = 'Pending';
    }
    return defaultFilter;
  }

  const setDefaultPageState = fromPathChange => {
    const defaultFilter = getDefaultFilter();
    setState({
      ...state,
      filterBy: defaultFilter,
      pageSize: initialPageSize,
      currentPage: 1,
      globalSearchVal: '',
      selectedRows: [],
    });

    // "fromPathChange" - This is for the pathchange when navbar tabs are changed or viewed back from detail view.
    // So "localFilterQuery" will be empty in case of pathchange from navbar but not in case of viewing back from detail view if already filter is applied.

    if (defaultFilter) {
      getPageTableData(
        1,
        initialPageSize,
        defaultFilter,
        fromPathChange ? localFilterQuery : filterQuery, // checking the path
        '',
      );
    }
  };

  const getPageContentTypeRole = filter => {
    let infoObj = {
      url: '',
      hasRole: 'N',
      key: '',
      cType: '',
    };
    if (pathname === '/invoice/myinvoice') {
      infoObj.cType = expenseFilters?.myInvoice?.[filter];
      infoObj.url = 'MY_INVOICE_SEARCH';
      infoObj.key = 'invoice';
      infoObj.title = 'My Invoices';
    } else if (pathname === '/invoice/myapproval') {
      infoObj.cType = expenseFilters?.invoiceApproval?.[filter];
      infoObj.hasRole = 'Y';
      infoObj.url = 'MY_INVOICE_APPROVALS';
      infoObj.key = 'invoice';
      infoObj.title = 'My Approvals';
    } else if (pathname === '/vendor/myvendor') {
      infoObj.cType = expenseFilters?.myVendor?.[filter];
      infoObj.url = 'MY_VENDOR_SEARCH';
      infoObj.key = 'vendor';
      infoObj.title = 'My Vendors';
    } else if (pathname === '/vendor/myapproval') {
      infoObj.hasRole = 'Y';
      infoObj.cType = expenseFilters?.vendorApproval?.[filter];
      infoObj.url = 'MY_VENDOR_APPROVALS';
      infoObj.key = 'vendor';
      infoObj.title = 'My Approvals';
    } else if (props.fromPage === 'dashboard') {
      if (pathname === 'dashboardAdminInvoice') {
        infoObj.cType = 'pending_on_me_invoices';
        infoObj.hasRole = 'Y';
        infoObj.url = 'MY_INVOICE_APPROVALS';
        infoObj.key = 'invoice';
      } else if (pathname === 'dashboardAdminVendor') {
        infoObj.hasRole = 'Y';
        infoObj.cType = 'pending_on_me_vendors';
        infoObj.url = 'MY_VENDOR_APPROVALS';
        infoObj.key = 'vendor';
      } else if (pathname === 'dashboardUserInvoice') {
        infoObj.cType = 'user_landing_page_invoices';
        infoObj.hasRole = 'N';
        infoObj.url = 'MY_INVOICE_SEARCH';
        infoObj.key = 'invoice';
      } else if (pathname === 'dashboardUserVendor') {
        infoObj.hasRole = 'N';
        infoObj.cType = 'submitted_vendors';
        infoObj.url = 'MY_VENDOR_SEARCH';
        infoObj.key = 'vendor';
      }
    }
    return infoObj;
  };

  const getPageTableData = (
    pageNumber,
    pageSize,
    filter,
    filterParams,
    globalSearch,
    fromRefresh,
  ) => {
    const { fromPage } = props;
    const obj = {
      filter_params: {},
      offset: pageSize * (pageNumber - 1),
      limit: fromPage === 'dashboard' ? 5 : pageSize * pageNumber,
      ordering: fromPage === 'dashboard' ? 'updated_on' : 'created_on',
    };

    let { cType, url, hasRole, key } = getPageContentTypeRole(filter);
    obj.content_type = cType;
    if (filterParams && Object.keys(filterParams).length) {
      obj.filter_params = JSON.stringify(filterParams);
    }
    if (globalSearch) {
      obj.value = globalSearch;
    }
    scrollTable();
    props.getExpense(obj, url, hasRole, key, callApiOnQueryChange, fromRefresh, filterParams);
  };

  const callApiOnQueryChange = () => {
    setDefaultPageState();
  };

  const onRowSelect = row => {
    let pendingItems = ['pending_on_me_invoices', 'pending_on_me_vendors'];
    // let isPendinigType = row?.object_data?.approval_status?.name === 'Pending';
    let isPendinigType = pendingItems.includes(cType);
    let ObjId = isPendinigType
      ? row.twf_id
      : row.resource_id || row.invoice_id || row.vendor_id;
    let apiEndPoint = isPendinigType ? 'TRACK_WORKFLOW' : 'RESOURCE_DETAILS';
    if (key === 'invoice') {
      history.push({
        pathname: `/invoice/${
          hasRole === 'N' ? 'myinvoice' : 'myapproval'
        }/detail/${ObjId}`,
        state: {
          urlType: row.editable ? '' : apiEndPoint,
          containerType: row.container_type,
        },
      });
    } else {
      history.push({
        pathname: `/vendor/${
          hasRole === 'N' ? 'myvendor' : 'myapproval'
        }/detail/${ObjId}`,
        state: {
          urlType: row.editable ? '' : apiEndPoint,
          containerType: row.container_type,
        },
      });
    }
  };
  const onCLickAction = (row, action) => {
    if (action === 'view') {
      let pendingItems = ['pending_on_me_invoices', 'pending_on_me_vendors'];
      // let isPendinigType = row?.object_data?.approval_status?.name === 'Pending';
      let isPendinigType = pendingItems.includes(cType);
      let ObjId = isPendinigType
        ? row.twf_id
        : row.resource_id || row.invoice_id || row.vendor_id;
      let apiEndPoint = isPendinigType ? 'TRACK_WORKFLOW' : 'RESOURCE_DETAILS';
      if (key === 'invoice') {
        history.push({
          pathname: `/invoice/${
            hasRole === 'N' ? 'myinvoice' : 'myapproval'
          }/detail/${ObjId}`,
          state: {
            urlType: row.editable ? '' : apiEndPoint,
            containerType: row.container_type,
          },
        });
      } else {
        history.push({
          pathname: `/vendor/${
            hasRole === 'N' ? 'myvendor' : 'myapproval'
          }/detail/${ObjId}`,
          state: {
            urlType: row.editable ? '' : apiEndPoint,
            containerType: row.container_type,
          },
        });
      }
    } else if (action === 'edit') {
      if (key === 'invoice') {
        history.push({
          pathname: `/invoice/myinvoice/editinvoice/${row.invoice_id}`,
        });
      } else {
        history.push({
          pathname: `/vendor/myvendor/editVendor/${row.vendor_id}`,
        });
      }
    } else if (action === 'delete') {
      setState({
        ...state,
        openDeleteInvVen: true,
        invVenId: row?.invoice_id || row?.vendor_id,
      });
    }
  };

  const handlePageChange = (pageNumber, pageSize = initialPageSize) => {
    const { filterBy, globalSearchVal } = state;
    setState({
      ...state,
      currentPage: pageNumber,
      pageSize,
      openDisputeDialog: false,
      selectedRows: [],
    });
    getPageTableData(
      pageNumber,
      pageSize,
      filterBy,
      filterQuery,
      globalSearchVal,
    );
  };

  const onFilterChange = item => {
    setState({
      ...state,
      filterBy: item.name,
      currentPage: 1,
      pageSize: initialPageSize,
      globalSearchVal: '',
      selectedRows: [],
      // filterQuery: {},
    });
    history.replace(`${pathname}?tab=${item.name}`);
    getPageTableData(1, initialPageSize, item.name, {}, '');
  };

  const config = TableConfig?.invoiceVendorHeader?.[pathname];
  let { hasRole, key, cType, title, url } = getPageContentTypeRole(
    state.filterBy,
  );
  let data = props.expenses && props.expenses?.[key]?.data;
  let count = (props.expenses && props.expenses?.[key]?.count) || 0;

  const handleCreate = url => {
    const { location: { pathname = '', search = '' } = {}, push } = history;
    push({ pathname: url, state: { prevPath: `${pathname}${search}` } });
  };

  const callGlobalSearchApi = (val, error) => {
    // let queryObj = {
    //   content_type:cType,
    //   value:val.trim(),
    // }
    // let url = '';
    // if(key === 'invoice'){
    //   url = 'GLOBAL_SEARCH_INVOICE'
    // }else{
    //   url = 'GLOBAL_SERACH_VENDOR'
    // }
    // props.getExpense(queryObj,url,hasRole,key);
    setState({
      ...state,
      currentPage: 1,
      pageSize: initialPageSize,
      globalSearchVal: val,
      globalSearchErrText: error,
    });
    getPageTableData(1, initialPageSize, state.filterBy, filterQuery, val);
  };

  const { userInfo = {}, fromPage, savedColumn } = props;
  const isDashboardView = fromPage === 'dashboard';
  const { location: { search = '' } = { search: '' } } = history;
  const filterChips = expenseFilters[pathname];
  const btnTextMap = {
    '/invoice/myinvoice': {
      url: '/invoice/myinvoice/createinvoice',
      name: 'Add Invoice',
    },
    '/vendor/myvendor': {
      url: '/vendor/myvendor/createView',
      name: 'Add Vendor',
    },
  };
  const buttonsArr = [
    {
      text: btnTextMap?.[pathname]?.name,
      action: () => handleCreate(btnTextMap?.[pathname]?.url),
      iconType: 'add',
      variant: 'primary',
    },
  ];

  let tableHeader = [...(config?.header || [])];
  if (
    state.filterBy === 'Saved' &&
    config?.header?.length &&
    pathname === '/invoice/myinvoice'
  ) {
    tableHeader.splice(6, 1);
  }

  let nativeSearchFields = [];
  if (pathname === '/invoice/myinvoice' || pathname === '/invoice/myapproval') {
    nativeSearchFields = expenseFilters.invoiceNativeFilters;
  } else {
    nativeSearchFields = expenseFilters.vendorNativeFilters;
  }

  const handleDialogActionClick = val => {
    let obj = {
      id: state.invVenId,
      delete_flag: true,
    };
    let apiUrl = key === 'invoice' ? 'INVOICE_UPDATE' : 'VENDOR_UPDATE';
    props.deleteInvoiceVendor(obj, apiUrl, () => {
      setState({
        ...state,
        openDeleteInvVen: false,
        currentPage: 1,
        pageSize: initialPageSize,
      });
      getPageTableData(1, initialPageSize, state.filterBy, {}, '');
    });
  };

  const postAllSavedColumn = checkedColumns => {
    const { postAllSavedColumn } = props;
    const { filterBy } = state;
    // checkedColumnObj[pathname] = {};
    // checkedColumnObj[pathname][filterBy] = checkedColumns;
    setState({
      ...state,
      checkedColumns,
    });

    const { cType } = getPageContentTypeRole(filterBy);

    const param = {
      content_type: cType,
      columns: JSON.stringify(checkedColumns),
    };

    postAllSavedColumn(param);
  };

  const getTableColumn = () => {
    let { checkedColumns } = state;
    let { savedColumn } = props;
    let col = [];
    if (checkedColumns && checkedColumns.length) {
      col = checkedColumns;
    } else if (savedColumn && savedColumn.length) {
      col = savedColumn;
    } else if (config?.defaultColumn) {
      col = [...config?.defaultColumn];
    }
    return col;
  };

  const updateSelectedRows = selectedRows => {
    setState({
      ...state,
      selectedRows,
    });
  };

  const onClickRefresh = () => {
    const {
      filterBy,
      globalSearchVal,
      currentPage,
      pageSize,
    } = state;
    setState({ ...state, selectedRows: [] });
    getPageTableData(
      currentPage,
      pageSize,
      filterBy,
      filterQuery,
      globalSearchVal,
      true,
    );
  };

  const getNoContentImage = () => {
    let tempImgObj = {
      primaryText: '',
      secondaryText: '',
      showButton: false,
    };
    let { globalSearch } = state;
    const { filterQuery } = props;

    let hasFilter = Object.keys(filterQuery).length || globalSearch;
    if (isDashboardView) {
      if (props.activeContainer === 'Invoices') {
        tempImgObj.noContentIcon = EMPTYSCREENHOMEINV;
        if (pathname === 'dashboardAdminInvoice') {
          tempImgObj.primaryText = 'Relax! All your approvals are done';
          tempImgObj.secondaryText =
            'Invoices submitted by your team will be visible here.';
        } else {
          tempImgObj.primaryText = 'Cheers! All your requests are done.';
          tempImgObj.secondaryText =
            'New invoice payments raised by you will be visible here';
        }
      } else {
        tempImgObj.noContentIcon = EMPTYSCREENHOMEVEN;
        if (pathname === 'dashboardAdminVendor') {
          tempImgObj.primaryText = 'Cheers! All your approvals are done';
          tempImgObj.secondaryText =
            'Vendors submitted by your team will be visible here.';
        } else {
          tempImgObj.primaryText = 'Cheers! All your requests are done.';
          tempImgObj.secondaryText =
            'New vendor requests raised by you will show up here';
        }
      }
    } else if (hasFilter) {
      tempImgObj.primaryText =
        'Sorry! No results found for the applied filters';
      tempImgObj.secondaryText = 'Please check the filters and try again.';
      tempImgObj.noContentIcon = FILTERNODATA;
    } else if (pathname === '/invoice/myinvoice') {
      tempImgObj.primaryText = 'Uh ho, no Invoices are added here';
      tempImgObj.secondaryText =
        'Invoices created by you will be visible here. Start adding Invoices.';
      tempImgObj.noContentIcon = EMPTYSCREENMYINV;
      tempImgObj.showButton = true;
    } else if (pathname === '/invoice/myapproval') {
      tempImgObj.noContentIcon = EMPTYSCREENHOMEINV;
      tempImgObj.primaryText = 'Relax! All your approvals are done';
      tempImgObj.secondaryText =
        'Invoices submitted by your team will be visible here.';
    } else if (pathname === '/vendor/myvendor') {
      tempImgObj.primaryText = 'Uh ho, no Vendors are added here';
      tempImgObj.secondaryText =
        'Vendors created by you will be visible here. Start adding Vendors.';
      tempImgObj.noContentIcon = EMPTYSCREENHOMEVEN;
      tempImgObj.showButton = true;
    } else if (pathname === '/vendor/myapproval') {
      tempImgObj.noContentIcon = EMPTYSCREENHOMEVEN;
      tempImgObj.primaryText = 'Relax! All your approvals are done';
      tempImgObj.secondaryText =
        'Vendors submitted by your team will be visible here.';
    }
    return tempImgObj;
  };

  const isInvoice = key === 'invoice';
  let tableColumn = !isDashboardView ? getTableColumn() : [];
  let noContentImage = data && data.length === 0 ? getNoContentImage() : null;

  const isBulkFlow =
    pathname === '/invoice/myapproval' &&
    ['All', 'Pending'].includes(state.filterBy);

  return (
    <Grid
      // ref={expenseRef}
      xs={24}
      direction="row"
      justify="flex-start"
      alignItems="flex-start"
      // className={props.userId || props.cardId ? '' : 'margin-t-10'}
    >
      {!isDashboardView ? (
        <>
          <Grid
            container
            direction="row"
            // justify="flex-end"
            alignItems="center"
            className="margin-t-10"
          >
            <Grid item xs={12} className="heading-h1 hw-text-body">
              {title}
            </Grid>
            <Grid container item xs={12} justify="flex-end">
              {' '}
              <DynamicButtons buttonsArr={buttonsArr} />{' '}
            </Grid>
          </Grid>
          <Grid
            xs={24}
            container
            justify="space-between"
            className={`padding-t-20 ${props.cardId ? 'padding-lr-20' : ''}`}
          >
            <Grid xs={12}>
              {filterChips &&
                Object.keys(filterChips)?.map(item => (
                  <Button
                    type="button"
                    size="small"
                    className={`hw-filter-chips font-12 margin-r-10 ${
                      filterChips[item].name === state.filterBy
                        ? ''
                        : 'chip-grey-bg'
                    }`}
                    variant={
                      filterChips[item].name === state.filterBy
                        ? 'primary'
                        : 'secondary'
                    }
                    text={filterChips[item].name}
                    onClick={() => {
                      onFilterChange(filterChips[item]);
                    }}
                  />
                ))}
            </Grid>
            <Grid xs={8}>
              <TextInput
                floatingLabelText=""
                hintText={
                  isInvoice
                    ? 'Search Invoice ID, Vendor Name or GSTIN'
                    : 'Search Vendor Name or GSTIN'
                }
                customInputParentStyle={{ margin: 'unset' }}
                value={state.globalSearchVal}
                type="text"
                // iconType={state.globalSearchVal ? "cross" : null}
                onChange={(e, val) => {
                  if (val.length === 0) {
                    setState({
                      ...state,
                      currentPage: 1,
                      pageSize: initialPageSize,
                      globalSearchVal: val,
                      globalSearchErrText: '',
                    });
                    getPageTableData(1, initialPageSize, state.filterBy, filterQuery, '');
                  } else {
                    setState({
                      ...state,
                      globalSearchVal: val,
                      globalSearchErrText: '',
                    });
                  }
                }}
                onEnter={() => {
                  if (
                    state.globalSearchVal &&
                    state.globalSearchVal.length >= 3
                  ) {
                    callGlobalSearchApi(state.globalSearchVal, '');
                  } else {
                    callGlobalSearchApi(
                      state.globalSearchVal,
                      'Please enter atleast 3 letters',
                    );
                  }
                }}
                errorText={state.globalSearchErrText || ''}
                errorType={state.globalSearchErrText && 'error'}
                onIconClick={() => {
                  if (
                    state.globalSearchVal &&
                    state.globalSearchVal.length >= 3
                  ) {
                    callGlobalSearchApi(state.globalSearchVal, '');
                  } else {
                    callGlobalSearchApi(
                      state.globalSearchVal,
                      'Please enter atleast 3 letters',
                    );
                  }
                }}
                iconType="search"
                extraIcon={state.globalSearchVal ? 'cross-fill' : ''}
                iconClass="padding-10 primary-color-bg white-color border-radius-4 margin-r-2"
                extraIconOnHover
                extraIconClick={() => {
                  if (state.globalSearchVal) {
                    setState({
                      ...state,
                      currentPage: 1,
                      pageSize: initialPageSize,
                      globalSearchVal: '',
                      globalSearchErrText: '',
                    });
                    callGlobalSearchApi('', '');
                  }
                }}
              />
            </Grid>
          </Grid>
        </>
      ) : null}
      <Grid justify="flex-end" className="invoice-bulk-actions-wrapper d-flex">
        {isBulkFlow && (
          <InvoiceBulk
            selectedRows={state.selectedRows}
            actions={['Approve', 'Decline']}
          />
        )}

        {!isDashboardView && (
          <>
            {!data ? (
              <Shimmer
                height={30}
                width={30}
                className="margin-r-10 margin-t-14"
              />
            ) : (
              <Icon
                type="refresh"
                size="large"
                interactive
                tabIndex={0}
                className="margin-t-10 filter-tooltip hw-top"
                tooltipText="Refresh"
                onClick={onClickRefresh}
              />
            )}
            <GenericFilter
              shimmer={!data}
              content_type={cType}
              content_key={key}
              nativeFilters={nativeSearchFields}
              hasRole={hasRole === 'Y'}
              isEtl
              count={count}
              defaultQuery={state.defaultQueryObj}
              filterQuery={filterQuery}
              tabIndex={0}
              applyFilter={query => {
                let { filterBy, globalSearchVal } = state;
                setState({
                  ...state,
                  // filterQuery: query,
                  currentPage: 1,
                  pageSize: initialPageSize,
                });
                getPageTableData(
                  1,
                  initialPageSize,
                  filterBy,
                  query,
                  globalSearchVal,
                );
              }}
            />
          </>
        )}
      </Grid>
      <Grid item xs={24} style={{ width: '100%' }} className="invoice-table-ui">
        <div className="invoice-table no-border-top">
          <div className="padding-t-20 padding-b-20">
            {!isDashboardView && (
              <Pagination
                currentPage={state.currentPage}
                totalDataSize={count}
                sizePerPage={state.pageSize}
                onPageChange={handlePageChange}
              />
            )}
          </div>
          <Table
            id={props?.history?.location?.search || cType}
            localPagination
            isDataFetched={data}
            headerElements={tableHeader}
            data={data || []}
            defaultCurrency={userInfo.default_currency}
            customTableOuterStyle={{
              height: `${!isDashboardView ? 'calc(100vh - 200px)' : '380px'}`,
            }}
            onClickAction={onCLickAction}
            actions={config?.actions || {}}
            // defaultColumn= {config?.defaultColumn}
            onRowSelect={onRowSelect}
            selectRows={isBulkFlow}
            selectMultipleRows={isBulkFlow}
            shimmerRow={10}
            shimmerColumn={4}
            colId={config?.col_option || {}}
            showNoMoreItems={!isDashboardView}
            enableColumnManagement={!isDashboardView}
            getColumn={params => {
              if (!isDashboardView && cType) {
                props.getAllSavedColumn(params); // get all column based on the contenet type
              }
            }}
            setColumn={params => {
              //call set table column api with incoming params;
            }}
            updateSelectedRows={updateSelectedRows}
            allRowsSelectable={false}
            maxRowSelection={data?.length}
            selectedRows={state.selectedRows}
            postAllSavedColumn={postAllSavedColumn}
            checkedColumns={tableColumn}
            savedColumn={savedColumn}
            contentType={cType}
            columnManagementTabIndex={0}
            primaryKey={config.primaryKey}
            noContent={
              <NoContent
                message={
                  <div>
                    <div className="body fw-600">
                      {noContentImage?.primaryText || ''}
                    </div>
                    <div className="body font-12 limitinfo padding-b-24">
                      {noContentImage?.secondaryText || ''}
                    </div>
                    {noContentImage?.showButton && (
                      <DynamicButtons
                        buttonsArr={buttonsArr}
                        fromPage={'NoContent'}
                      />
                    )}
                  </div>
                }
                icon={noContentImage?.noContentIcon}
                placement="center"
              />
            }
          />
        </div>
      </Grid>
      <ActionConfirmation
        btn2Action={handleDialogActionClick}
        openDialogbox={state.openDeleteInvVen}
        onDialogboxClose={() => setState({ ...state, openDeleteInvVen: false })}
        dialogTitle={`Delete ${key}`}
        dialogBody={`Are you sure you want to delete ?`}
      />
    </Grid>
  );
}
Expenses.propTypes = {
  userId: PropTypes.string,
  getExpense: PropTypes.func,
  expenses: PropTypes.object,
  location: PropTypes.object,
  history: PropTypes.object,
  pathname: PropTypes.string,
  cardId: PropTypes.string,
  getSearchFields: PropTypes.func,
  searchFields: PropTypes.object,
  clearexpense: PropTypes.func,
  setDispute: PropTypes.func,
  transactionType: PropTypes.string,
  isAdmin: PropTypes.bool,
  showSnackbar: PropTypes.func,
  userInfo: PropTypes.object,
  disputeReason: PropTypes.array,
  getDisputeReason: PropTypes.func,
  getExpenseDetailsUser: PropTypes.func,
  updateDisputeInTxn: PropTypes.func,
  TxnDispute: PropTypes.object,
  savedColumn: PropTypes.array,
};

Expenses.defaultProps = {
  isAdmin: false,
  savedColumn: [],
};

export default Expenses;
